module.exports = __webpack_public_path__ + "static/media/mediathek.ef010467.svg";